__turbopack_context__.v({
  "card": "ComfortMortgage-module-scss-module__oTHeIa__card",
  "cardDesc": "ComfortMortgage-module-scss-module__oTHeIa__cardDesc",
  "cardDescHtml": "ComfortMortgage-module-scss-module__oTHeIa__cardDescHtml",
  "cardGrow": "ComfortMortgage-module-scss-module__oTHeIa__cardGrow",
  "cardTitle": "ComfortMortgage-module-scss-module__oTHeIa__cardTitle",
  "content": "ComfortMortgage-module-scss-module__oTHeIa__content",
  "descRow": "ComfortMortgage-module-scss-module__oTHeIa__descRow",
  "grid": "ComfortMortgage-module-scss-module__oTHeIa__grid",
  "header": "ComfortMortgage-module-scss-module__oTHeIa__header",
  "icon": "ComfortMortgage-module-scss-module__oTHeIa__icon",
  "intro": "ComfortMortgage-module-scss-module__oTHeIa__intro",
  "root": "ComfortMortgage-module-scss-module__oTHeIa__root",
  "rows": "ComfortMortgage-module-scss-module__oTHeIa__rows",
  "title": "ComfortMortgage-module-scss-module__oTHeIa__title",
});
